var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"overflow":"hidden","display":"block","position":"absolute","height":"100%","width":"100%"},attrs:{"frameborder":"0","src":"http://bsv.shadhinbd.com/docs"}})
}
var staticRenderFns = []

export { render, staticRenderFns }